import { push } from "connected-react-router";
import { call, put, take } from "redux-saga/effects"
import actionTypes from "../../actions/actionTypes"
import { putError, putSuccess } from "../helpers";
import config from '../../config.json'


function* putChange(actionType, pk, data) {
    yield put({
        type: actionType,
            payload: {
                pk: pk,
                data: data
            }
    })
}

function* iteratePut(actionType, idArr, itemsArr) {
    for(let i = yield 0; yield i < idArr.length; yield i++) {
        const pk = yield idArr[i]
        const item = yield itemsArr[pk]

        yield call(putChange, actionType, pk, item)
    }
}

function* getCollectionsFromScheme(scheme) {
    const collections = yield []

    for(let i = yield 0; yield i < scheme.length; yield i++) {
        const weekScheme = yield scheme[i]

        for(let j = yield 0; yield j < weekScheme.timeFilters.length; yield j++) {
            const filter = yield weekScheme.timeFilters[j]

            yield collections.push(filter.collection)
        }
    }

    return collections
}

function* update(payload) {
    try {
        const { pk, itemCollections, newItemCollections, updatedItemCollections, deletedItemCollections, screenData } = yield payload 

        yield call(iteratePut, actionTypes.SIGNAGE_COLLECTION_CREATE, newItemCollections, itemCollections)
        yield call(iteratePut, actionTypes.SIGNAGE_COLLECTION_UPDATE, updatedItemCollections, itemCollections)
        
        const collections = yield call(getCollectionsFromScheme, screenData.scheme)

        yield call(putChange, actionTypes.SIGNAGE_SCREEN_UPDATE, pk, {
            collections: collections,
            ... screenData
        })

        yield call(iteratePut, actionTypes.SIGNAGE_COLLECTION_DELETE, deletedItemCollections, itemCollections)
        yield put(push(config.routes.signage.path))
        yield call(putSuccess, actionTypes.SIGNAGE_SCREEN_UPDATE_SUCCESS, {})
    } catch(e) {
        yield console.log(e)
        yield call(putError, actionTypes.SIGNAGE_SCREEN_UPDATE_ERROR, e.message)
    }
}

function* watchSignageScreenUpdateRequest() {
    try {
        while(true) {
            const request = yield take(actionTypes.SIGNAGE_SCREEN_UPDATE_REQUEST)

            yield call(update, request.payload)
        }

    } catch(e) {
        console.log('eeee', e)
        console.log('error!!!!!', e.message)
    }
}

export default watchSignageScreenUpdateRequest